// extracted by mini-css-extract-plugin
export var alertIcon = "_u8-0";